import { endOfMonth, format, parseISO } from 'date-fns';

/** yyyy-MM из поля «Период» счёта (может быть «2026-02» или «2026-02-01»). */
export function getInvoiceMonthKey(period: string | null | undefined): string | null {
    if (!period) return null;
    const m = String(period).match(/^(\d{4}-\d{2})/);
    return m?.[1] ?? null;
}

/** Строка для BaseDateTimePicker range: «yyyy-MM-dd - yyyy-MM-dd» — первый и последний день месяца. */
export function getDefaultTrafficPeriodForMonth(period: string | null | undefined): string | null {
    const key = getInvoiceMonthKey(period);
    if (!key) return null;
    const d = parseISO(`${key}-01`);
    const from = format(d, 'yyyy-MM-dd');
    const to = format(endOfMonth(d), 'yyyy-MM-dd');
    return `${from} - ${to}`;
}

export function trafficPeriodStringToRange(raw: string | null | undefined): { from: string | null; to: string | null } {
    const dates = String(raw ?? '').match(/\d{4}-\d{2}-\d{2}/g) ?? [];
    return {
        from: dates[0] ?? null,
        to: dates[1] ?? null,
    };
}

export function serviceToTrafficPeriodString(
    el: { traffic_period_from?: string | null; traffic_period_to?: string | null },
    fallback?: { from?: string | null; to?: string | null },
): string | null {
    const from = el.traffic_period_from ?? fallback?.from ?? null;
    const to = el.traffic_period_to ?? fallback?.to ?? null;
    if (from && to) return `${from} - ${to}`;
    return null;
}
